import { Grid, GridProps } from "@mui/material";

type ListingReviewsGridProps = GridProps;

export const ListingReviewsGrid = ({ children }: ListingReviewsGridProps) => {
  return (
    <Grid container spacing={"10px"}>
      {children}
    </Grid>
  );
};
